import { lazy } from 'react';

const LoginPage = lazy(() => import('../features/authentication/pages/LoginPage'));
const ForgotPasswordPage = lazy(() => import('../features/authentication/pages/ForgotPasswordPage'));
const DashboardPage = lazy(() => import('../features/dashboard/pages/DashboardPage'));
const HomePageCMS = lazy(() => import('../features/home-page/pages/HomePageCMS'));
const AboutUsCMS = lazy(() => import('../features/about-us/pages/AboutUsCMS'));
const ContactCMS = lazy(() => import('../features/contact/pages/ContactCMS'));
const OrganizationStructureCMS = lazy(() => import('../features/organization-structure/pages/OrganizationStructureCMS'));
const LoanProductsCMS = lazy(() => import('../features/products/loan-products/pages/LoanProductsCMS'));
const SavingsSharesCMS = lazy(() => import('../features/products/savings-shares/pages/SavingsSharesCMS'));
const NewsAndEventsCMS = lazy(() => import('../features/news-events/pages/NewsAndEventsCMS'));
const NewsEditPage = lazy(() => import('../features/news-events/pages/NewsEditPage'));
const MediaLibraryPage = lazy(() => import('../features/media-library/pages/MediaLibraryPage'));
const MenusPage = lazy(() => import('../features/menus/pages/MenusPage'));
const FooterPage = lazy(() => import('../features/footer-management/pages/FooterPage'));
const TopHeaderCMS = lazy(() => import('../features/top-header-management/pages/TopHeaderCMS'));
const FeedbackManagementPage = lazy(() => import('../features/feedback-management/pages/FeedbackManagementPage'));

export const authRoutes = [
  { path: '/login', component: LoginPage },
  { path: '/forgot-password', component: ForgotPasswordPage },
];

export const dashboardRoutes = [
  { path: '/dashboard', component: DashboardPage },
];

export const pageRoutes = [
  { path: '/pages/home', component: HomePageCMS },
  { path: '/pages/about-us', component: AboutUsCMS },
  { path: '/pages/contact', component: ContactCMS },
  { path: '/pages/organization-structure', component: OrganizationStructureCMS },
];

export const productRoutes = [
  { path: '/products/loans', component: LoanProductsCMS },
  { path: '/products/savings-shares', component: SavingsSharesCMS },
];

export const mediaCentreRoutes = [
  { path: '/media-centre', component: NewsAndEventsCMS },
  { path: '/news/edit/:id', component: NewsEditPage },
];

export const mediaRoutes = [
  { path: '/media-library', component: MediaLibraryPage },
];

export const menuRoutes = [
  { path: '/menus', component: MenusPage, permission: 'edit' },
];

export const footerRoutes = [
  { path: '/footer', component: FooterPage, permission: 'edit' },
];

export const topHeaderRoutes = [
  { path: '/top-header', component: TopHeaderCMS, permission: 'edit' },
];

export const feedbackRoutes = [
  { path: '/feedback', component: FeedbackManagementPage },
];

